import { motion } from "framer-motion";
import { fadeUp, viewport } from "@/lib/motion";
import { PROCESS } from "@/lib/data";

export const Process = () => {
  return (
    <section id="process" data-testid="process-section" className="py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-3xl mb-16 md:mb-20">
          <motion.p variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport}
            className="text-xs font-semibold tracking-[0.25em] uppercase text-gold mb-6">Our Process</motion.p>
          <motion.h2 variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} custom={1}
            className="font-serif font-light text-4xl sm:text-5xl leading-tight text-primary">
            From first consultation to lasting implementation.
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-4 gap-px bg-border border border-border">
          {PROCESS.map((p, i) => (
            <motion.div key={p.step} data-testid={`process-step-${i}`}
              variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} custom={i}
              className="bg-background p-8 md:p-10 relative group hover:bg-[hsl(var(--muted)/0.5)] transition-colors duration-500">
              <span className="font-serif text-5xl md:text-6xl font-light text-[hsl(var(--gold)/0.55)] group-hover:text-gold transition-colors duration-500">{p.step}</span>
              <h3 className="font-serif text-2xl font-normal text-primary mt-6 mb-3">{p.title}</h3>
              <p className="text-sm font-light leading-relaxed text-muted-foreground">{p.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
